const baseAdminUrl = (organizationId) => `/admin/api/v1/organizations/${organizationId}/tableau`;
export const enableUrl = (organizationId) => `${baseAdminUrl(organizationId)}/enable`;
export const maxLimitUrl = (organizationId) => `${baseAdminUrl(organizationId)}/max_limit`;
export const adminSiteInfoUrl = (organizationId) => `${baseAdminUrl(organizationId)}/tableau_site`;
export const adminSelfService = (organizationId) => `${baseAdminUrl(organizationId)}/self_service`;
export const tableauSiteDataUrl = (organizationId) =>
  `/sysconfig/api/v1/organizations/${organizationId}/tableau/tableau_site`;
